var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"height":_vm.size,"viewBox":"0 0 7 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('line',{attrs:{"x1":"0.353553","y1":"0.646447","x2":"6.57578","y2":"6.86867","stroke":_vm.color}}),_c('line',{attrs:{"x1":"0.424401","y1":"6.86868","x2":"6.64662","y2":"0.646454","stroke":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }